import { render, staticRenderFns } from "./SurveyFoodItemList.vue?vue&type=template&id=54068b7e&scoped=true&lang=pug&"
import script from "./SurveyFoodItemList.vue?vue&type=script&lang=js&"
export * from "./SurveyFoodItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54068b7e",
  null
  
)

export default component.exports